import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { textFilterAnimation } from './utilities'

gsap.registerPlugin(ScrollTrigger)

export const initCollections = () => {
	const intros = document.querySelectorAll('.collections__intro')
	const productLists = document.querySelectorAll('.collections__products')

	if (!intros.length) return

	intros[0].classList.add('active')

	const showCollection = (index) => {
		intros.forEach(intro => intro.classList.remove('active'))
		intros[index].classList.add('active')	
	}

	productLists.forEach((products, index) => {
		ScrollTrigger.create({
			trigger: products,
			start: 'top center',
			end: 'bottom center',
			onEnter: ({progress, direction, isActive}) => {
				showCollection(index)
			},
			onEnterBack: ({progress, direction, isActive}) => {
				showCollection(index)
			}
		})
	})
}

export default () => {}
